<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <!-- 面包屑 -->
    <div class="crumbs">
      <div>关于我们  > 下载专区</div>
    </div>

    <div class="ny-tabs">
      <ul>
        <li v-for="item in types"
          :class="[type === item.value ? 'action' : '']"
          @click="typeChange(item.value)"
        >{{ item.name }}</li>
      </ul>
    </div>

    <div class="container-width" v-loading="isLoading">
      <div class="download">
        <!-- <h3>裁判工作用表及资料</h3> -->
        <ul>
          <li v-for="item in list" :key="item.id">
            <div>
              <div class="name">{{ item.title }}</div>
              <div class="info">文件大小：<span class="name">{{ item.fileSize | filterSize }}</span> &nbsp; &nbsp; 下载次数：<span class="name">{{ item.downloadNum || 0 }}</span></div>
            </div>
            <div class="blue mouse" @click="download(item)">
              <i class="el-icon-download"></i>
              立即下载
            </div>
          </li>
        </ul>
        <div class="pagination-box" v-if="pageInfo.total > 0" style="padding-top: 24px;">
        <el-pagination
            background
            :page-size="pageInfo.size"
            :total="pageInfo.total"
            @current-change="currentChange"
            layout="prev, pager, next">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { getFileInfoPage, getBanner, fileInfoDownload } from '@/service/apis/common'
const toFixed2 = (num) => {
  if ((num + '').includes('.')) {
    num = num.toFixed(2)
    return parseFloat(num)
  } 
  return num
}
export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'Download',
  filters: {
    filterSize (size) {
      if (!size) {
      }
      if (size < 1024) {
        return toFixed2(size) + ' B'
      } else {
        let kb = (size / 1024)
        if (kb < 1024) {
          return toFixed2(kb) + ' Kb'
        }
        let mb = (size / 1024 / 1024)
        if (mb < 1024) {
          return toFixed2(mb) + ' Mb'
        }
        let gb = (size / 1024 / 1024 / 1024)
        return toFixed2(gb) + ' G'
      }
    }
  },
  data() {
    return {
      types: [{
        name: '各类表格',
        value: 1
      }, {
        name: '赛事资料',
        value: 2
      }],
      type: 1, // 1-各类表格 2-赛事资料,
      banner: [],
      list: [],
      isLoading: false,
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total:0
      }
    }
  },
  created() {
    getBanner(this).then(data => {
      // banner 12
      if (data[12]) {
        this.banner = [...data[12]]
      }
    })

    this.getList()
  },
  methods: {
    currentChange (page) {
      this.pageInfo.pageIndex = page
      this.getList()
    },
    typeChange (value) {
      this.type = value
      this.getList()
    },
    getList () {
      let opt = {
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        type: this.type
      }
      this.isLoading = true
      getFileInfoPage.call(this, opt).then(res => {
        if (res.errCode === 0) {
          let { total, records } = res.data
          this.pageInfo.total = total
          this.list = []
          records && records.length && records.forEach(item => {
            this.list.push(item)
          })
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    download (file) {
      // fileLink
      window.open(file.fileLink)
      this.updateDownload(file)
    },
    updateDownload(file) {
      fileInfoDownload.call(this, file.id).then((res) => {
        if (res.errCode == 0) {
          setTimeout(() => {
            file.downloadNum += 1
          }, 500)
        }
      })
    }
  },
}
</script>
<style scoped>
.download ul {
  display: block;
  border: solid 1px #ddd;
  border-radius: 8px;
}
.download ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 22px;
  padding: 6px 24px;
}
.download ul li:nth-child(2n-1) {
  background-color: #dfe3e8;
}
.download .name {
  font-size: 14px;
  color: #333;
}
.download .info {
  font-size: 12px;
  color: #999;
}
.blue {
  color: #0e2bd9;
}
.download {
  padding: 36px 16px 48px 16px;
}
.download h3 {
  height: 60px;
  line-height: 60px;
  font-size: 28px;
  color: #333;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4c2ac9;
}

</style>
